export default "__VITE_ASSET__f6d49911__"